import React from "react";
import { Modal } from "sprint-common-web";

import { LookupHistoryItem, LookupHistoryList } from "./LookupHistoryList";

type LookupHistoryModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onClick: (item: LookupHistoryItem) => void;
};

export const LookupHistoryModal = ({ isOpen, onClick, onClose }: LookupHistoryModalProps): JSX.Element => {
    return (
        <Modal isOpen={isOpen} headerText="Lookup history" onDismiss={onClose} size="md" displayCloseButton={true}>
            <LookupHistoryList onClick={onClick} />
        </Modal>
    );
};
